enum AccountRequestInitiatedFrom {
  Client = 'clientdashboard',
  Advisor = 'advisordashboard',
}

export default AccountRequestInitiatedFrom;
